/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import "antd/dist/reset.css";
import "../../containers/customLayout.css";
import {
  Col,
  Row,
  Image,
  Divider,
  Space,
  Dropdown,
  Button,
  Popconfirm,
} from "antd";
import { useNavigate, Link } from "react-router-dom";
import {
  UserOutlined,
  ProfileOutlined,
  LogoutOutlined,
  EyeOutlined,
} from "@ant-design/icons";

import { login, logout, getProfile } from "../../security/AppSecurity";
import {
  RenderAnonymous,
  RenderAuthenticated,
} from "../../security/ToggleViews";

export const HeaderView = () => {
  const [userData, setUserData] = useState(getProfile());
  const username = userData.firstName;
  const navigate = useNavigate();
  let registrationURL = "/register";

  const handleMenuClick = (e) => {};
  const items = [
    {
      label: <Link to="/changepassword">Update Password</Link>,
      key: "1",
      icon: <EyeOutlined />,
    },
    {
      label: <Link to="/profile">Manage Profile</Link>,
      key: "2",
      icon: <ProfileOutlined />,
    },
    {
      label: <a onClick={logout}>Logout</a>, 
      //(   
      //   <Popconfirm
         
      //     title="Are you sure you want to logout right now?"
      //     onConfirm={logout}
      //     // onCancel={() => cancel()}
      //     placement="bottomRight"
      //     okText="Yes"
      //     cancelText="No"
      //   >
      //     Logout
      //   </Popconfirm>
      // ),
      key: "3",
      icon: <LogoutOutlined />,
    },
  ];

  const menuOptions = {
    items,
    onClick: handleMenuClick,
  };

  return (
    <div>
      <div>
        <Row>
          <Col xs={8} md={8}>
            <div>
              <a href="https://www.dst.gov.za/" target="_blank">
                <Image
                  style={{ paddingRight: "10px" }}
                  className="dst-logo"
                  src={require("../../assets/DST-logo.jpg")}
                  alt="National Youth Service (NYS) DSTI logo"
                  preview={false}
                />
              </a>
            </div>
          </Col>
          <Col className="center-align" xs={5} md={8}>
            <div>
              <a href="/">
                <Image
                  className="seims-logo"
                  src={require("../../assets/seims-logo.png")}
                  alt="SEIMS logo"
                  preview={false}
                />
              </a>
            </div>
          </Col>
          {/* <Col span={6}>
        <PageHeader title="Home" />
      </Col> */}
          <Col xs={9} md={8} className="admin-container-landing">
            {/* <RenderAuthenticated> */}

            <RenderAnonymous>
              <Image
                className="user-logo"
                src={require("../../assets/user.png")}
                alt="SEIMS Public Portal"
                preview={false}
              />

              <a onClick={login}>Login</a>
              <Divider
                type="vertical"
                style={{ backgroundColor: "#000", fontSize: "18px" }}
              />
              <a onClick={() => navigate(registrationURL)}>Register</a>
            </RenderAnonymous>
            <RenderAuthenticated>
              <Dropdown menu={menuOptions} className="profile">
                <Space>
                  <Button>
                    {username}
                    <UserOutlined />
                  </Button>
                </Space>
              </Dropdown>
            </RenderAuthenticated>
          </Col>
        </Row>
      </div>

      <div />
    </div>
  );
};
